import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import ReportList from "../../../common/ReportList";
import Constants from "../../../../common/Constants";
import { convertSecondsToHours } from "../../../../components/common/util";
import { setOperatordData } from "../../../../redux/feature/manufacturing_app/operatorReportSlice";
import { getCurrentDate } from "../../../../common/Validations";
import "./OperatorsEfficiency.scss";

const formatEfficiency = (value) =>
  value === null || value === undefined ? "N/A" : `${value}%`;

const OperatorsReports = () => {
  const { t } = useTranslation();
  const [displayFilter, setDisplayFilter] = useState(false);
  const [requiredFrom, setRequiredFrom] = useState("");
  const [requiredTo, setRequiredTo] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleViewJobcard = (row) => {
    dispatch(
      setOperatordData({
        operatorUserId: row.operatorUserId,
        dateFrom: requiredFrom
          ? moment(requiredFrom, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY")
          : getCurrentDate(),
        dateTo: requiredTo
          ? moment(requiredTo, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY")
          : requiredFrom
            ? moment(requiredFrom, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY")
            : getCurrentDate(),
      })
    );
    navigate("/OperatorsEfficiency");
  };

  const handleSearchParams = (searchedParams) => {
    if (searchedParams) {
      setRequiredFrom(searchedParams.requiredFrom || "");
      setRequiredTo(searchedParams.requiredTo || searchedParams.requiredFrom || "");
    }
  };

  const columnsData = [
    {
      name: "Operator ID",
      selector: (row) => row.operatorUserId,
      sortable: true,
      width: "180px",
      cell: (row) => <p className="m-0 p-0 pt-1">{row.operatorUserId}</p>,
    },
    {
      name: "Operator Name",
      selector: (row) => row.operatorUserName,
      sortable: true,
      width: "200px",
      cell: (row) => <p className="m-0 p-0 pt-1">{row.operatorUserName}</p>,
    },
    {
      name: "Jobcard Operations",
      selector: (row) => row.totalCount,
      sortable: true,
      width: "190px",
      cell: (row) => (
        <button className="btnTable" onClick={() => handleViewJobcard(row)}>
          {row.totalCount}
        </button>
      ),
    },
    {
      name: "Actual Duration",
      selector: (row) => row.totalActualDuration,
      sortable: true,
      width: "190px",
      cell: (row) => (
        <span className="bg-table-status bg-table-new-status">
          {convertSecondsToHours(row.totalActualDuration)}
        </span>
      ),
    },
    {
      name: "Standard Duration",
      selector: (row) => row.totalTargetDuration,
      sortable: true,
      width: "190px",
      cell: (row) => (
        <span className="bg-table-status bg-table-new-status">
          {convertSecondsToHours(row.totalTargetDuration)}
        </span>
      ),
    },
    {
      name: "Cycle Time Coverage",
      selector: (row) => row.cycleTimeCount,
      sortable: true,
      width: "190px",
      cell: (row) => (
        <span
          className={`operator-coverage ${
            row.missingCycleTimeCount ? "operator-coverage--warning" : ""
          }`}
          title={
            row.missingCycleTimeCount
              ? `${row.missingCycleTimeCount} operation(s) have no cycle time in Process Master`
              : "All operations have a Process Master cycle time"
          }
        >
          {row.cycleTimeCount} / {row.totalCount}
        </span>
      ),
    },
    {
      name: "Efficiency",
      selector: (row) => row.efficiencyPercentage,
      sortable: true,
      width: "160px",
      cell: (row) => (
        <span
          className="operator-efficiency-value"
          title="Efficiency = Process Master standard duration / actual duration × 100"
        >
          {formatEfficiency(row.efficiencyPercentage)}
        </span>
      ),
    },
  ];

  return (
    <main className="generatejobcard main" id="main">
      <Row className="justify-center subContent">
        <Col xs={8} md={8} className="rightSide">
          <div className="rightSideInner timesheet">
            <h2 className="mainTitle">
              Operators Report -{" "}
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {getCurrentDate()}
              </span>
            </h2>
            <p className="subText">Operator performance based on configured process cycle times</p>
            <p className="operator-efficiency-formula">
              Efficiency = Process Master standard duration ÷ actual duration × 100
            </p>
          </div>
        </Col>
        <Col xs={4} md={4} className="leftSide">
          <Button
            type="button"
            variant="primary"
            size="lg"
            className="btn btn-primary float-right searchFilter-btn"
            onClick={() => setDisplayFilter(!displayFilter)}
          >
            <i className="bi bi-filter"> </i>
          </Button>
        </Col>
        <hr />
      </Row>

      <ReportList
        columnsData={columnsData}
        displayFilter={displayFilter}
        operatorFilter={true}
        disableWeekends={true}
        resetFilerBox={setDisplayFilter}
        pageName={t("msg_reports.msg_operator_report.operator_report_title")}
        pageURL={Constants.REPORTS.OPERATORREPORTS.list}
        name={Constants.REPORTS.OPERATORREPORTS.name}
        parameter={{
          currentDate: moment(new Date(), "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY"),
        }}
        searchedParams={handleSearchParams}
        selectableRow={false}
      />
    </main>
  );
};

export default OperatorsReports;
